import './MoreIcon.pcss';
import React, { MouseEvent } from 'react';
import classnames from 'classnames';

export type Props = {
  size?: number;
  className?: string;
  color?: string;
  onClick?: (e?: MouseEvent<HTMLDivElement>) => any;
};

const MoreIcon = (props: Props) => {
  const { className, onClick, color } = props;
  const size = props.size || 24;

  const styles = {
    width: size,
    height: size,
  };

  const circleStyle = color ? { backgroundColor: color } : {};

  const classList = classnames('more-icon', className);

  return (
    <div style={styles} className={classList} onClick={onClick}>
      <div className="more-icon__wrapper">
        <div style={circleStyle} className="more-icon__circle" />
        <div style={circleStyle} className="more-icon__circle" />
        <div style={circleStyle} className="more-icon__circle" />
      </div>
    </div>
  );
};

export { MoreIcon };
